import { useContext } from 'react'

import { Context } from 'Root/Contexts/Ip'

export function useCurrentIp(): string | null {
  const ip = useContext(Context)

  if (!ip) {
    return null
  }

  return ip
}
